document.addEventListener('DOMContentLoaded', () => {
  const ppAcceptBtn = document.querySelector('.js-accept-pp')
  const ppWrap = document.querySelector('.js-pp-wrap')
  const ppPopup = document.querySelector('.js-popup')
  const ppPopupCloseBtn = document.querySelector('.js-popupCloseBtn')

  if (!localStorage.getItem('ppAccepted') && ppWrap) {
    ppWrap.classList.add('shown')
    if (ppPopup) ppPopup.classList.remove('bottom')
  }

  if (localStorage.getItem('ppAccepted') && ppPopup) {
    ppPopup.classList.add('bottom')
  }

  if (ppAcceptBtn) {
    ppAcceptBtn.addEventListener('click', () => {
      if (ppWrap) ppWrap.classList.remove('shown')
      if (ppPopup) ppPopup.classList.add('bottom')
      localStorage.setItem('ppAccepted', '1')
    })
  }

  if (ppPopupCloseBtn) {
    ppPopupCloseBtn.addEventListener('click', () => {
      ppPopup.classList.add('hidden')
    })
  }
})
